<template>
  <div class="security">
    <div class="content">
      <div class="row">
        <el-row :gutter="20">
          <el-col :span="12">
            <p>造价咨询资质证书</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon4.png" />
          </el-col>
          <el-col :span="12">
            <p>工程监理资质</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon10.png" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <p>建筑施工资质</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon7.png" />
          </el-col>
          <el-col :span="12">
            <p>工程咨询单位资信证书</p>
            <img class="img" src="https://classoss.zhuokairui.cn/img/dingming/imgs/index/icon5.png" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>
<style scoped>
  .img{width: 100%;height: auto;}
  .security p{text-align: center;font-size: 14px;font-weight: bold;}
  .row {border: 1px solid #f2f2f2;margin-bottom: 20px;border-radius: 10px;padding: 20px;}
  .row div{text-align: center;font-size: 32px;font-weight: bold;}
</style>



// WEBPACK FOOTER //
// src/pages/security.vue